import React, { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Loader from "../../Global/Loader";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { withNamespaces } from "react-i18next";
import Docs from "../Components/Docs"
import LoadDocs from "./components/loadDocs"
import ImageUpload from './components/ImageUpload'
import FormCreator from "../Components/FormBuilder";
import { form_load_docs } from "./components/form"
import { model_load_docs } from "./components/model"
import { connect } from "react-redux";
import Axios from "axios";
import { Services } from "../../../repositories/clients/Services";
import { Menu, Dropdown, Modal as confirmMessage } from "antd";
import { MoreOutlined, CloudDownloadOutlined, MonitorOutlined, DeleteOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
const { confirm } = confirmMessage;

const filesAccepted = ['application/pdf', 'image/jpeg'];
const maxSizeFile = 10000000;

const rolDelete = ['1']
const rolView = ['1', '2', '3', '4']
const rolDownload = ['1', '2', '3', '4']

function Documents(params) {
	const [loader, setLoader] = useState(false);
	const [customers] = useState(params.clients);
	const [user] = useState(params._user);
	const [rolId] = useState(params._rolId);
	const [file, setFile] = useState([])
	const [disabledButton, setDisabledButton] = useState(true)
	const [model, setModel] = useState({ ...model_load_docs() });
	const [catalogs] = useState({ ...model_load_docs().catalogs });
	const [modal, setModal] = useState(false);

	const [columns] = useState([
		{
			label: params.t("documents_table_actions"), key: "FileName", custom: (value) => (
				<>
					<Dropdown
						overlay={
							< Menu>
								{
									rolDownload.includes(rolId) ?
										<Menu.Item >
											<div className="d-flex align-items-center">
												<CloudDownloadOutlined />
												<a href={value.URL} className="classLink">
													<span style={{ color: '#535353' }} className="pl-2">{params.t("documents_actions_download")}</span>
												</a>
											</div>
										</Menu.Item> : false
								}
								{
									rolView.includes(rolId) ?
										<Menu.Item onClick={() => {
											window.open(`${Services.DOCUMENTS.path}documents/view?url=${value.URL}`);
										}}>
											<div className="d-flex align-items-center">
												<MonitorOutlined />
												<span style={{ color: '#535353' }} className="pl-2">{params.t("documents_actions_view")}</span>
											</div>
										</Menu.Item> : false
								}
								{
									rolDelete.includes(rolId) ?
										<Menu.Item onClick={() => confirmAction(value)}>
											<div className="d-flex align-items-center">
												<DeleteOutlined />
												<span style={{ color: '#535353' }} className="pl-2">{params.t("documents_actions_delete")}</span>
											</div>
										</Menu.Item> : false
								}
							</Menu>
						}
						placement="topRight"
					>
						<MoreOutlined className="btn-expander" style={{ fontSize: "26px", cursor: "pointer" }} />
					</Dropdown >
				</>)
		},
		{ label: params.t("documents_table_customer"), key: "Customer" },
		{ label: params.t("documents_table_category"), key: "Description" },
		{ label: params.t("documents_table_name"), key: "DocumentName" },
		{ label: params.t("documents_table_date"), key: "CreationDate" }
	])
	const [data, setData] = useState([])

	async function dataCatalogs() {
		try {
			let url = `${Services.DOCUMENTS.path}documents/catalogs`;
			let body = { customers: customers }
			let res = await Axios.post(url, body);

			catalogs.customer = res.data.data.catCustomers
			catalogs.category = res.data.data.catCategory
		} catch (error) {
			console.log("🚀 ~ catalogs ~ error:", error)
		}
	}

	async function dataDocs() {
		try {
			let url = `${Services.DOCUMENTS.path}documents/dataDocs`;
			let body = { customers: customers }
			let res = await Axios.post(url, body);
			setData(res.data.data)
			setLoader(true)
		} catch (error) {
			console.log("🚀 ~ dataDocs ~ error:", error)
		}
	}
	function callFile(dataFile) {
		let modelSend = { ...model.docs };
		let required = ValidatorSchema(modelSend, form_load_docs.form)
		if (filesAccepted.indexOf(dataFile[0]?.file.type) > -1 && dataFile[0]?.file.size <= maxSizeFile) {
			setFile(dataFile)
			setDisabledButton(!required)
		} else {
			setFile([])
			setDisabledButton(true)
		}
	}

	function ValidatorSchema(model, form) {
		let required = true
		for (let i = 0; i < form.length; i++) {
			const item = form[i];
			if (item.required) {
				if (!Boolean(model[item.id].value)) {
					required = false
				}
			}
		}
		return required
	}

	function handleChnge(data, item) {
		let modelSend = { ...model.docs };
		if (item.type === "select") {
			modelSend[item.id].value = data ? data.id : null
		} else if (item.type === "input") {
			modelSend[item.id].value = data
		}
		let required = ValidatorSchema(modelSend, form_load_docs.form)
		if (required && file.length !== 0) setDisabledButton(false)
		else setDisabledButton(true)

		setModel({ model, ...model })
	}

	const toggle = () => {
		setModal(!modal)
		setFile([])
		setModel({ ...model_load_docs() })
	};

	const loadDocument = useCallback(async () => {
		let modelSend = { ...model.docs };
		setModal(!modal)
		setLoader(!loader)
		const formData = new FormData();
		if (file) {
			formData.append("file", file[0].file);
			formData.append("customer", modelSend.customer.value);
			formData.append("category", modelSend.category.value);
			formData.append("name", modelSend.name.value);
			formData.append("type", file[0].file.name.slice(file[0].file.name.lastIndexOf(".")));
			formData.append("UserId", user);

			let url = `${Services.DOCUMENTS.path}documents/loadDoc`;

			fetch(`${url}`, { method: "POST", body: formData, mode: 'cors', headers: new Headers() })
				.then((response) => {
					setTimeout(() => {
						dataDocs()
						setFile([])
						setModel({ ...model_load_docs() })
						setDisabledButton(true)
						Swal.fire({
							icon: "success",
							title: params.t("documents_save_success"),
							showConfirmButton: false,
							timer: 2500
						});
					}, 2000);
				})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [file])

	function confirmAction(item) {
		confirm({
			title: <hr className="hr-popover" style={{ margin: "0" }}></hr>,
			icon: false,
			cancelText: "No",
			okText: params.t("yes"),
			content: (
				<div>
					<div className="col-12" style={{ textAlign: "center" }}>
						<p class="seacargo-pop-icon">
							<em class="fas fa-exclamation-triangle"></em>
						</p>
						<span>{params.t("documents_suere_delete_document")}</span>
					</div>
				</div>
			),
			onOk: () => { deleteDocument(item) },
		});
	}

	const deleteDocument = useCallback(async (data) => {
		try {
			let url = `${Services.DOCUMENTS.path}documents/deleteDoc`;
			let body = { item: data, UserId: user }
			let res = await Axios.put(url, body);
			if (res.status === 200) {
				dataDocs()
				Swal.fire({
					icon: "success",
					title: params.t("documents_delete_success"),
					showConfirmButton: false,
					timer: 2500
				});
			}
		} catch (error) {
			console.log("🚀 ~ deleteDocument ~ error:", error)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user])

	useEffect(() => {
		dataDocs();
		dataCatalogs();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<Loader hidden={loader} />
			<ContentWrapper>
				<div className="content-heading">
					<legend className="legendBasic">
						<i className="demo-icon icon-folder-empty" />
						{params.t("documents_title")}
					</legend>
				</div>
				<Docs columns={columns} data={data} >
					{
						rolId === '1' ?
							<LoadDocs
								title={params.t('documents_modal_title')}
								buttonSave={params.t('documents_modal_button_save')}
								funtionButton={loadDocument}
								disabledButton={disabledButton}
								toggle={toggle}
								openModal={modal}
							>
								<ImageUpload
									callFile={callFile}
									lng={params.t}
									filesAccepted={filesAccepted}
									maxSizeFile={maxSizeFile}
								/>
								<div className="row pt-4">
									<FormCreator form_component={form_load_docs.form} model={model.docs} translate={params.t} catalogs={catalogs} onchange={handleChnge} />
								</div>
							</LoadDocs>
							: ''
					}
				</Docs>
			</ContentWrapper>
		</>
	)
}
const mapStateToProps = (state) => ({
	clients: state.header.clients,
});
export default withNamespaces()(connect(mapStateToProps)(withRouter(Documents)));

